import React, { useEffect, useState } from 'react';
import { Typography, Slider } from '@mui/material';
import { ButtonAddTexture } from './ButtonAddTexture';
import { Edit } from '../../constructor/work/Edit';
import { EventAddSubstrate } from '../../helpers/events';
import { ButtonAddPruning } from './ButtonAddPruning';
import { useHandlerNotificationApp } from '../../hooks/useHandlerNotificationApp';
import { ButtonAddScale } from './ButtonAddScale';

export const LoadImageTexture = () => {
  const { addNotification } = useHandlerNotificationApp();
  const [opacityTexture, setOpacityTexture] = useState(() => {
    if (Edit && Edit.drawingSubstrate) {
      return Edit.drawingSubstrate.material.opacity;
    }
    return 0;
  });

  const handleChangeStateSubstrate = () => {
    if (Edit && Edit.drawingSubstrate) {
      const value = Edit.drawingSubstrate.material.opacity;
      setOpacityTexture(value);
    }
  };
  const handlerChangeSlider = (event: Event, value: number | number[]) => {
    if (Edit && Edit.drawingSubstrate) {
      Edit.drawingSubstrate.material.opacity = +value;
      setOpacityTexture(+value);
    }
  };
  const handlerSliderClick = () => {
    if (!Edit?.drawingSubstrate) {
      addNotification({
        messageError: 'Для изменения прозрачности необходимо добавить чертеж-подложку',
        typeMessage: 'info',
      });
    }
  };

  useEffect(() => {
    document.addEventListener(EventAddSubstrate, handleChangeStateSubstrate);
    return () => {
      document.removeEventListener(EventAddSubstrate, handleChangeStateSubstrate);
    };
  }, []);

  return (
    <>
      <Typography fontSize={24} color="#fff">
        ШАГ 1
      </Typography>
      <Typography mb={3} color="#fff">
        Загрузите чертеж покрываемой плоскости
      </Typography>
      <ButtonAddTexture />
      <ButtonAddPruning />
      <ButtonAddScale />
      <Typography color="white" gutterBottom>
        Прозрачность подложки
      </Typography>
      <Slider
        onMouseDown={handlerSliderClick}
        value={opacityTexture}
        onChange={handlerChangeSlider}
        valueLabelDisplay="auto"
        step={0.01}
        min={0}
        max={1}
      />
    </>
  );
};
